import React from 'react';

import { useTranslation } from 'react-i18next';

import { useTimezone } from '@platform/core/timezone';

import type { Timezone } from '@packages/fenrir/fenrir-provider/timezone';

import { MenuItemCheckbox } from './menu-item-checkbox';

export const TimezoneMenuItems = ({
  handleCloseMenu,
}: {
  handleCloseMenu: () => void;
}) => {
  const { t } = useTranslation('app', {
    keyPrefix: 'appBar.settingsMenu.timezone',
  });
  const {
    availableTimezones,
    timezone: activeTimeZone,
    setTimezone,
  } = useTimezone();

  const handleOnClick = (timezone: Timezone) => {
    setTimezone(timezone);
    handleCloseMenu();
  };

  return (
    <>
      {availableTimezones.map((timezone) => (
        <MenuItemCheckbox
          key={timezone}
          label={t(timezone)}
          selected={activeTimeZone === timezone}
          onClick={() => handleOnClick(timezone)}
        />
      ))}
    </>
  );
};
